import UnsubscribeFeed from './UnsubscribeFeed';

export default UnsubscribeFeed;
